module.exports = "<div class=\"col s12 m6\"> <card> <card-image :src=imageUrl> <card-title>Card Title</card-title> </card-image> <card-content> <p>this is image description</p> </card-content> <card-action> <a href=#!>Link A</a> </card-action> </card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/cards/image-card.vue
 ** module id = 195
 ** module chunks = 0
 **/